import { IShowable } from "../../interfaces/IShowable";
import { LabelButton } from "../../ui/LabelButton";
import { LabelIconButton } from "../../ui/LabelIconButton";
import { Padding } from "../../utils/Padding";
import { RectSize } from "../../utils/RectSize";
import { CardSuit } from "../card/Card";
import { LoaderFileKeys } from "../constant/AppConstants";
import { OptionsDataManager } from "../managers/OptionsDataManager";
import { AppLocalization } from "../localization/AppLocalization";
import { AppSettings } from "../managers/AppSettings";
import { Players } from "../player/Players";
import { TableScreen } from "../screen/TableScreen";
import { TrumpSuit } from "../state/TableStateMachine";
import { GetCardSuitIconTextureStatesData, TrumpIconType } from "../utils/GetCardSuitIconTextureData";
import { TrumpSuitToCardSuit } from "../utils/TrumpsSuitToCardSuit";
import { AppTimings } from "../data/AppConstants";


export enum SelectedTrumpViewLayout {
    ROUNDED,
    SNAP_TOP,
}

/**
 * shows selected trump suit
 * update: (for Coinche &Contree?) also shows Bid Choice (80,90,...,180,Capot,Capot Belote,Generale,Generale Belote)
 * update: (for Coinche &Contree?) also shows COINCHE/SURCOINCHE (2x/4x) is any
 */
export class SelectedTrumpView 
    extends Phaser.GameObjects.Container
    implements IShowable
{
    public table: TableScreen;
    /**
     * Player that chose the trumpSuit
     */
    public playerIndex: number;
    /**
     * Chosen trumpSuit
     */
    public trumpSuit: TrumpSuit;

    // private iconTextureData: TextureData;
    // private label_txt: string;

    // private bg: Phaser.GameObjects.Image;
    private bg: Phaser.GameObjects.Graphics;
    private txtPlayer: Phaser.GameObjects.Text;
    // private icon: Phaser.GameObjects.Image;
    // private txtIcon: Phaser.GameObjects.Text;
    /**
     * Trump icon. Shows selected trump suit
     * - white circle background
     * - suit is an icon (hearts|diamonds|spades|clubs) OR text (NT|AT)
     * - used in: Belote, Coinche, Contree
     */
    private btnTrump: LabelIconButton;
    // private sBid: string;
    // private sContra: string;
    /**
     * Bid icon. Shows bid choice.
     * - white circle|roundedRect background (depends on bif choice)
     * - bid choice is a text (80|90|..|180*|C|CP*|G|GB*)
     *   * long texts use roundedRect background
     * used in: Coinche, Contree
     */
    private btnBid: LabelButton;
    /**
     * 'Contra' icon. Shows Coinche|Contree|Double|Redouble, if applicable.
     * - white circle
     * used in: Coinche, Contree
     */
    private btnContra: LabelButton;
    // white circle under icon
    // private iconBg: Phaser.GameObjects.Image;

    protected isShowing: boolean = false;
    protected size: RectSize;
    protected padding: Padding = new Padding(20, 20, 0, 0); // left, right, top, bottom
    // horizontal spacing between mini-components (right aligned)
    protected spacing: number = 10;
    protected curLayout: SelectedTrumpViewLayout;


    public Show(animated: boolean = true): void
    {
        // console.log("TablePopupWindow::Show; animated=", animated);

        // this.SetInteractive(true);

        // kill tweens
        // this.scene.tweens.killTweensOf(..);

        // reset
        // this.scale = 0;
        this.alpha = 0;

        // if animate
        const genericShowDuration = OptionsDataManager.GetTiming(AppTimings.genericShowDuration);
        if (animated) {
            this.scene.tweens.add({
                targets: this,
                alpha: 1,
                // scale: 1,
                duration: genericShowDuration,
                ease: AppSettings.ease.genericShowHideEase,
            })
        }
        else {
            //
            this.alpha = 1;
            // this.scale = 1;
        }
        this.isShowing = true;
    }

    public Hide(animated: boolean = true): void
    {
        // console.log("PopupBase::Hide; animated=", animated);

        // this.SetInteractive(false);

        // kill tweens
        // this.scene.tweens.killTweensOf();

        // ref
        
        // if animate
        const genericHideDuration = OptionsDataManager.GetTiming(AppTimings.genericHideDuration);
        if (animated) {
            this.scene.tweens.add({
                targets: this,
                alpha: 0,
                // scale: 0,
                duration: genericHideDuration,
                ease: AppSettings.ease.genericShowHideEase,
            })
        }
        else {
            // 
            this.alpha = 0;
            // this.scale = 0;
        }
        this.isShowing = false;
    }

    public IsShowing(): boolean
    {
        return this.isShowing;
    }

    public Init(table: TableScreen): void
    {
        this.table = table;
    }

    public Build(): void
    {
        this.bg = this.scene.make.graphics({x: 0, y: 0, fillStyle: { color: 0x000000, alpha: 0.9 }});
        this.add(this.bg);

        this.txtPlayer = this.scene.make.text({
                style:{
                    color: "#fff",
                    fontSize: "30px",
                    fontFamily: AppSettings.fontFamilies.MontserratBold,
                    metrics: AppSettings.metrics.montserratBold30,
                }
            }
        );
        this.txtPlayer.setOrigin(0, 0.5);
        this.add(this.txtPlayer);

        // btnTrump
        this.btnTrump = new LabelIconButton(this.scene);
        this.btnTrump.InitBase({
                out:{ texture:LoaderFileKeys.ui, frame:"circle-white.png" },
            }, 
            false, 0.8
        );
        this.btnTrump.InitLabel({
                out: {
                    color: "#000",
                    fontSize: "25px",
                    fontFamily: AppSettings.fontFamilies.MontserratBold,
                    metrics: AppSettings.metrics.montserratBold25,
                }
            },
        );
        this.btnTrump.label.setOrigin(0.5);
        this.btnTrump.InitIcon(
            GetCardSuitIconTextureStatesData(CardSuit.SPADES, TrumpIconType.SELECTED_TRUMP_VIEW),
            null,
            0.4,
        );
        // this.btnTrump.PostInit();
        this.add(this.btnTrump);

        // btnBid
        this.btnBid = new LabelButton(this.scene);
        this.btnBid.InitBase({
                out:{ texture:LoaderFileKeys.ui, frame:"circle-white.png" },
            }, 
            false, 0.8
        );
        this.btnBid.InitLabel({
                out: {
                    color: "#000",
                    fontSize: "25px",
                    fontFamily: AppSettings.fontFamilies.MontserratBold,
                    metrics: AppSettings.metrics.montserratBold25,
                }
            },
        );
        this.btnBid.label.setOrigin(0.5);
        // this.btnBid.PostInit();
        this.btnBid.setVisible(false);
        this.add(this.btnBid);

        // btnContra
        this.btnContra = new LabelButton(this.scene);
        this.btnContra.InitBase({
                out:{ texture: LoaderFileKeys.ui, frame: "circle-white.png" },
            }, 
            false, 0.8
        );
        this.btnContra.InitLabel({
                out: {
                    color: "#000",
                    fontSize: "25px",
                    fontFamily: AppSettings.fontFamilies.MontserratBold,
                    metrics: AppSettings.metrics.montserratBold25,
                }
            },
        );
        this.btnContra.label.setOrigin(0.5);
        // this.btnContra.PostInit();
        this.btnContra.setVisible(false);
        this.add(this.btnContra);
    }

    public SetLayout(layout: SelectedTrumpViewLayout, updateView: boolean = false): void
    {
        this.curLayout = layout;
        if (updateView) {
            this.UpdateView();
        }
    }

    public GetLayout(): SelectedTrumpViewLayout
    {
        return this.curLayout;
    }

    /**
     * Set playerIndex. 
     * Update player text.
     * Optionally update layout (or defer update).
     * 
     * NOTE: trumpSuit always exists/shows on this component
     */
    public SetPlayerIndex(playerIndex: number, updateView: boolean = false): void
    {
        this.playerIndex = playerIndex;
        const playerName = this.table.players.GetPlayerByIndex(this.playerIndex).GetName()
            .replace(Players.PLAYER_NAME, AppLocalization.GetSharedData(AppLocalization.GetCurLanguageId()).general.playerName)

        // update view
        this.txtPlayer.text = playerName;
        // update layout
        if (updateView) {
            this.UpdateView();
        }
    }

    /**
     * Updates view from data change (playerIndex|sBid|trumpSuit|sContra).
     * Optionally update layout (or defer update).
     * 
     * NOTE: trumpSuit always exists/shows on this component
     */
    public SetTrumpSuit(trumpSuit: TrumpSuit, updateView: boolean = false): void
    {
        this.trumpSuit = trumpSuit;
        // update view
        switch(this.trumpSuit) {
            case TrumpSuit.NOTRUMPS:
                this.btnTrump.label.text = AppLocalization.GetSharedData().general.noTrumpsShortText;
                this.btnTrump.label.setVisible(true);
                this.btnTrump.icon.setVisible(false);
                break;
            case TrumpSuit.ALLTRUMPS:
                this.btnTrump.label.text = AppLocalization.GetSharedData().general.allTrumpsShortText;
                this.btnTrump.label.setVisible(true);
                this.btnTrump.icon.setVisible(false);
                break;
            case TrumpSuit.SPADES:
            case TrumpSuit.CLUBS:
            case TrumpSuit.DIAMONDS:
            case TrumpSuit.HEARTS:
                const cardSuit = TrumpSuitToCardSuit(this.trumpSuit);
                const iconTextureStatesData = GetCardSuitIconTextureStatesData(cardSuit, TrumpIconType.SELECTED_TRUMP_VIEW);
                this.btnTrump.icon.setTexture(iconTextureStatesData.out.texture, iconTextureStatesData.out.frame);
                this.btnTrump.icon.setVisible(true);
                this.btnTrump.label.setVisible(false);
                break;
            case TrumpSuit.UNDEFINED:
            default:
                console.log("SelectedTrumpView: trumpSuit undefined. why are you setting this?");
                break;
        }
        // update layout
        if (updateView) {
            this.UpdateView();
        }
    }

    /**
     * Set data for Bid mini-component. 
     * Show/hide said component. 
     * Optionally update layout (or defer update).
     * 
     * NOTE: Bid only shows in Coinche and Contree. There is no Bid mini-view in Belote.
     * 
     * @param sBid undefined = hide Bid mini-component
     */
    public SetBidValue(sBid: string = undefined, updateView: boolean = false): void
    {
        // console.log("SetBidValue");

        // got bid text
        if (sBid) {
            // set bg (size depends on size of label)
            const btnBidBgFrame: string = sBid.length > 2 ? 
                "rect-rounded-02-white.png" :   // long text = circle background
                "circle-white.png";             // short text = rounded rect background
            this.btnBid.view.setFrame(btnBidBgFrame);
            // set label
            this.btnBid.label.text = sBid;
            // show bid mini-component
            this.btnBid.setVisible(true);
        }
        // no bid text
        else {
            // hide big mini-component
            this.btnBid.setVisible(false);
        }

        if (updateView) {
            this.UpdateView();
        }
    }

    /**
     * Set data for Contra mini-component. 
     * Show/hide said component. 
     * Optionally update layout (or defer update).
     * 
     * NOTE: Contra only shows in Coinche and Contree. There is no Contra mini-view in Belote.
     * 
     * @param sBid undefined = hide Bid mini-component
     */
    public SetContra(sContra: string = undefined, updateView: boolean = false): void
    {
        // got bid text
        if (sContra) {
            // set label
            this.btnContra.label.text = sContra;
            // show bid mini-component
            this.btnContra.setVisible(true);
        }
        // no bid text
        else {
            // hide big mini-component
            this.btnContra.setVisible(false);
        }

        if (updateView) {
            this.UpdateView();
        }
    }

    /**
     * @alike: UpdateView
     * @param size 
     */
    public SetSize(size: RectSize, updateView: boolean = false): void
    {
        this.size = size;

        if (updateView) {
            this.UpdateView();
        }
    }

    public GetSize(): RectSize
    {
        return this.size;
    }

    /**
     * Update sizes and positions of inner content.
     */
    public UpdateView(): void
    {
        this.bg.clear();
        // layout with score view visible
        if (this.curLayout == SelectedTrumpViewLayout.SNAP_TOP) {
            // 20 px hack to overlap-snap to scoreView
            // this.bg.fillStyle(0x000000, 0.9);
            // this.bg.fillRoundedRect(0, 0, this.size.width, 20, {tl:0,tr:0,bl:0,br:0});
            this.bg.fillStyle(0x333333, 0.9);
            this.bg.fillRoundedRect(0, 20, this.size.width, this.size.height, {tl:0, tr:0, bl:20, br:20});
        }
        else 
        // layout with score view hidden (Options toggle)
        if (this.curLayout == SelectedTrumpViewLayout.ROUNDED) {
            this.bg.fillStyle(0x000000, 0.9);
            this.bg.fillRoundedRect(0, 20, this.size.width, this.size.height, {tl:20, tr:20, bl:20, br:20});
        }

        const halfHeight = 20 + this.size.height/2;
        let rightOffset = this.size.width - this.padding.right;

        // txtPlayer
        this.txtPlayer.setPosition(this.padding.left, halfHeight);
        // btnTrump
        const btnTrumpHalfWidth = this.btnTrump.view.displayWidth/2;
        rightOffset -= btnTrumpHalfWidth;
        this.btnTrump.setPosition(rightOffset, halfHeight);
        rightOffset = rightOffset - btnTrumpHalfWidth - this.spacing;
        // btnBid
        if (this.btnBid.visible) {
            const btnBidHalfWidth = this.btnBid.view.displayWidth/2;
            rightOffset -= btnBidHalfWidth;
            this.btnBid.setPosition(rightOffset, halfHeight);
            rightOffset = rightOffset - btnBidHalfWidth - this.spacing
        }
        // btnContra
        if (this.btnContra.visible) {
            const btnContraHalfWidth = this.btnContra.view.displayWidth/2;
            rightOffset -= btnContraHalfWidth;
            this.btnContra.setPosition(rightOffset, halfHeight);
        }
    }
}